(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/frejaeid/poll.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/frejaeid/poll.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.views.frejaeid.Poll = Marionette.View.extend({
    template: function template(data) {
      if (this.status < 2) {
        return svs.player_login.templates.frejaeid_poll_start(data);
      }

      return svs.player_login.templates.frejaeid_app_started(data);
    },
    behaviors: [{
      behaviorClass: svs.player_login.behaviors.FrejaEidErrorHandling
    }, {
      behaviorClass: svs.player_login.behaviors.TabHandler
    }],
    source: {
      'ios-hybrid-mobile': 5,
      'android-hybrid-mobile': 5,
      'ios-hybrid-tablet': 6,
      'web-mobile': 1,
      'web-tablet': 2,
      'web-desktop': 3
    },
    events: {
      'click .js-open-frejaeid': 'onOpenFrejaEidClick',
      'click .js-cancel-poll': 'onCancelPollClick',
      'click .js-back-from-other-device': 'onBackFromOtherDeviceClick',
      'click .js-cancel-from-this-device': 'onCancelFromThisDeviceClick',
      'click .js-sign-up': 'onNavigateToCustomerRegistration'
    },
    initialize: function initialize() {
      delete this.pollingTimeoutId;
      this.status = 0;
      delete this.authRef;
      delete this.loader;
      this.loginStartTime = svs.components.Storage.browser.get('loginStartTime', 'player-login');
      this.errorRetries = 2;
      delete this.authRestarts;
    },
    onAttach: function onAttach() {
      var _this = this;

      var logger = svs.core.log.getLogger('modules:player-login');

      if (!this.model.get('authRef')) {
        logger.error("No authRef in model, server side data: ".concat(svs.player_login.data.login.authRef));
      }

      if (!svs.core.detect.formfactor.mobile()) {
        this.loader = new svs.components.Loader('.js-frejaeid-loader-large-inverted');
        this.loader.show(300, 'inverted');
      }

      this.pollingTimeoutId = setTimeout(function () {
        _this.pollCustomerLogin();
      }, 500);

      if (this.model.get('startFrejaEid')) {
        this.startFrejaEid();
      } else {
        this.qrCodeGenerate();
      }

      this.authRestarts = 0;
    },
    onOpenFrejaEidClick: function onOpenFrejaEidClick(e) {
      e.preventDefault();
      svs.utils.url.navigate(svs.player_login.utils.url.getFrejaEidAppUrl(this.model.get('authRef')));
    },
    onCancelPollClick: function onCancelPollClick(e) {
      var _this2 = this;

      e.preventDefault();
      this.abortCustomerLogin();
      this.cancelPoll(function () {
        svs.player_login.router.navigate("/?returnUrl=".concat(_this2.model.get('returnUrl')), true);
      });
    },
    onBackFromOtherDeviceClick: function onBackFromOtherDeviceClick(e) {
      var _this3 = this;

      e.preventDefault();
      this.abortCustomerLogin();
      this.cancelPoll(function () {
        _this3.model.set('otherFrejaDevice', false);

        svs.player_login.router.navigate("/?returnUrl=".concat(_this3.model.get('returnUrl')), true);

        _this3.render();
      });
    },
    onCancelFromThisDeviceClick: function onCancelFromThisDeviceClick(e) {
      var _this4 = this;

      e.preventDefault();
      this.abortCustomerLogin();
      this.cancelPoll(function () {
        svs.utils.url.navigate(_this4.model.get('cancelUrl') || svs.utils.urlMapping.get('startPage'));
      });
    },
    onNavigateToCustomerRegistration: function onNavigateToCustomerRegistration(e) {
      e.preventDefault();
      svs.utils.url.navigate("".concat(svs.utils.urlMapping.get('customerRegistrationHome'), "?").concat(this.model.toQueryString()));
    },
    startFrejaEid: function startFrejaEid() {
      var url = svs.player_login.utils.url.getFrejaEidAppUrl(this.model.get('authRef'));
      svs.utils.url.navigate(url);
      this.loader = new svs.components.Loader('.js-frejaeid-loader-large-inverted');
      this.loader.show(300, 'inverted');
    },

    storeCustomerType: function storeCustomerType(customerType, callback) {
      svs.components.Storage.browser.set('customerType', 'customer_registration', customerType, svs.components.Storage.constants.EXPIRES_1H, callback);
    },
    cancelPoll: function cancelPoll(callback) {
      var options = {
        method: 'POST',
        path: '/player/frejaeid/cancelauth',
        context: this,
        data: {
          authRef: this.model.get('authRef')
        }
      };
      svs.core.jupiter.call(options, function (response) {
        svs.core.log.getLogger('modules:player-login').info("Cancel poll: ".concat(response));
        Boolean(callback) && callback();
      }, function (xhr) {
        var errorCode = xhr && xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code;
        svs.core.log.getLogger('modules:player-login:error-codes').info(errorCode);
        Boolean(callback) && callback();
      });
    },

    pollCustomerLogin: function pollCustomerLogin() {
      var maxRestarts = 1,
      options = {
        method: 'POST',
        path: '/player/frejaeid/getauthresult/login',
        context: this,
        data: {
          authRef: this.model.get('authRef'),
          source: this.source[svs.core.data.capabilities.channel] || 1
        }
      };
      svs.core.log.getLogger('modules:player-login').debug("authRef: ".concat(this.model.get('authRef')));
      svs.core.jupiter.call(options, function (response) {
        var _this5 = this;

        var successEvent = {
          category: 'Users',
          action: 'Login Success',
          opt_label: 'frejaeid'
        },
            newCustomerEvent = {
          category: 'Users',
          action: 'Customer Registration'
        };
        var isBlocked, lastLoginTime;
        var dateNow = Date.now(); 

        var afterLastLoginTimeSetCallback;
        var self = this,
            logger = svs.core.log.getLogger('modules:player-login');
        this.errorRetries = 2;

        if (response.status === 2) {
          this.loader && this.loader.hide();
          this.status = response.status;
          this.render();
        } else {
          this.status = response.status;
        }

        if (response.status === 3) {
          logger.debug("Login aborted by user ".concat(response.status));
          svs.core.flash('info', {
            title: 'Inloggning avbruten',
            area: svs.components.dialog.area.POPUP,
            branding: svs.components.dialog.branding.TUR,
            icon: 'exclamation-sign',
            time: svs.components.dialog.autoClose.MEDIUM 

          }, function () {
            svs.utils.url.navigate(_this5.model.get('returnUrl') || svs.utils.urlMapping.get('startPage'));
          });
        } else if (response.status === 4) {
          logger.debug("Login with Freja eID canceled by RP, status: ".concat(response.status));
          this.showErrorMessage(response.status);
        } else if (response.status === 5) {
          if (this.authRestarts < maxRestarts) {
            logger.debug("Login with Freja eID timed out, but we make a retry to prolong timeout for customer, status: ".concat(response.status)); 

            this.authRestarts = this.authRestarts + 1;
            this.abortCustomerLogin();
            svs.player_login.radio.request('authRef').done(function (authRef) {
              _this5.model.set('authRef', authRef);

              history.pushState({}, '', "frejaeidpoll?authref=".concat(authRef, "&ofd=").concat(_this5.model.get('otherFrejaDevice')));

              _this5.qrCodeGenerate();

              _this5.pollingTimeoutId = setTimeout(function () {
                _this5.pollCustomerLogin();
              }, 1000);
            }).fail(function (err) {
              _this5.triggerMethod('frejaEidError', err);
            });
          } else {
            logger.debug("Login with Freja eID timed out, status: ".concat(response.status));
            this.showErrorMessage(response.status, 'Det tog för lång tid att godkänna din inloggning med Freja eID, var vänlig försök igen.');
          }
        } else if (response.status === 7) {
          logger.debug("Login with Freja eID canceled because of more than one authentication transaction for the same user at the same time, status: ".concat(response.status));
          this.showErrorMessage(response.status, 'För många samtidiga försök att logga in med Freja eID för samma användare, vänligen vänta en stund och försök igen.');
        } else if (response.session || response.status === 6) {
          if (this.loginStartTime) {
            successEvent.opt_value = Date.now() - this.loginStartTime;
          }

          svs.components.analytics.trackEvent(successEvent, this);
          isBlocked = response && response.session && response.session.isBlocked;

          if (isBlocked || response.userNotifications && (response.userNotifications.HAS_SUSPENSION || response.userNotifications.SHOW_SUSP_REMINDER)) {
            if (isBlocked) {
              this.model.set('action', 'show_national_suspension_message');
            } else if (response.userNotifications.HAS_SUSPENSION) {
              this.model.set('action', 'show_suspension');
            } else {
              this.model.set('action', 'show_suspension_reminder');
            }

            afterLastLoginTimeSetCallback = function afterLastLoginTimeSetCallback() {
              svs.player_login.router.navigate('/spelpaus', true);
            };
          } else {
            afterLastLoginTimeSetCallback = function afterLastLoginTimeSetCallback() {
              svs.utils.url.navigate(self.model.get('returnUrl'));
            };
          }

          lastLoginTime = response && response.lastLoginTime || ''; 

          if (lastLoginTime === '') {
            logger.info('No lastLoginTime in session response');
          } else if (svs.player_login.utils.date.parseLastLoginTime(lastLoginTime, true) === svs.player_login.utils.date.format(dateNow, true)) {
            logger.info("lastLoginTime from backend (".concat(lastLoginTime, ") seems to be currentLoginTime. It is the same date, same hour, same minute and same second"));
          } else {
            logger.info("lastLoginTime from backend (".concat(lastLoginTime, ")"));
          }

          if (response.userNotifications && response.userNotifications.PART_OF_CAMPAIGN) {
            svs.core.userSession.set('partofcampaign', true, function () {
              svs.core.userSession.set('lastLoginTime', svs.player_login.utils.date.parseLastLoginTime(lastLoginTime, false), afterLastLoginTimeSetCallback);
            }); 
          } else {
            svs.core.userSession.set('lastLoginTime', svs.player_login.utils.date.parseLastLoginTime(lastLoginTime, false), afterLastLoginTimeSetCallback);
          }
        } else if (response.status === 21) {
          response.deviceId = undefined;
          response.requestId = undefined;
          response.requestInfo = undefined;
          response.ssn = this.model.get('ssn');

          if (this.model.get('returnNewCustomer')) {
            response.returnUrl = this.model.get('returnUrl'); 
          }

          newCustomerEvent.opt_label = 'started_retail_customer_from_frejaeid';
          svs.components.analytics.trackEvent(newCustomerEvent, function () {
            this.storeCustomerType('retail', function () {
              svs.utils.form.postToUrl(svs.utils.urlMapping.get('customerRegistrationCompletion'), response, 'POST');
            });
          }, this);
        } else if (response.status) {
          this.pollingTimeoutId = setTimeout(function () {
            _this5.pollCustomerLogin();
          }, 1000);
          svs.events.publish('/core/session/status', response.status);
        } else {
          svs.components.analytics.trackEvent({
            category: 'Users',
            action: 'Login Failure',
            opt_label: 'frejaeid',
            opt_value: '666'
          });
          this.handleFrejaEidError();
        }
      }, function (xhr) {
        var _this6 = this;

        var errorCode = xhr && xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.code;

        if (errorCode && errorCode === 666 && this.errorRetries > 0) {
          this.errorRetries = this.errorRetries - 1;
          this.pollingTimeoutId = setTimeout(function () {
            _this6.pollCustomerLogin();
          }, 1000);
          svs.core.log.getLogger('modules:player-login').info('Received network error, retrying');
        } else {
          if (this.loader) {
            this.loader.hide();
          }

          svs.components.analytics.trackEvent({
            category: 'Users',
            action: 'Login Failure',
            opt_label: 'frejaeid',
            opt_value: errorCode || 666
          });
          svs.core.log.getLogger('modules:player-login:error-codes').info(errorCode);
          this.handleFrejaEidError(xhr);
        }
      });
    },
    handleFrejaEidError: function handleFrejaEidError(err) {
      this.triggerMethod('frejaEidError', err);
    },
    showErrorMessage: function showErrorMessage(status) {
      var _this7 = this;

      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Det går inte att logga in just nu, var vänlig försök igen lite senare.';

      var errorFunction = function errorFunction() {
        svs.utils.url.navigate(_this7.model.get('returnUrl') || svs.utils.urlMapping.get('startPage'));
      };

      if (this.loader) {
        this.loader.hide();
      }

      svs.components.analytics.trackEvent({
        category: 'Users',
        action: 'Login Failure',
        opt_label: 'frejaeid',
        opt_value: status || 666
      });
      svs.core.log.getLogger('modules:player-login:error-codes').info(status);
      var dialog = new svs.components.dialog.Confirm({
        type: svs.components.dialog.type.ERROR,
        title: 'Misslyckad inloggning',
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: errorMessage
        }],
        actions: [{
          title: 'OK',
          callback: errorFunction
        }]
      });
      svs.components.dialog.api.add(dialog);
    },

    abortCustomerLogin: function abortCustomerLogin() {
      clearTimeout(this.pollingTimeoutId);
    },
    onDestroy: function onDestroy() {
      if (this.pollingTimeoutId) {
        clearTimeout(this.pollingTimeoutId);
      }
    },
    qrCodeGenerate: function qrCodeGenerate() {
      var qrCodeId = this.model.get('authRef');

      if (qrCodeId !== undefined && qrCodeId.length > 0) {
        qrCodeId = svs.player_login.utils.url.getFrejaEidAppUrl(qrCodeId);
        $('#qrCode').empty().qrcode({
          size: 120,
          color: '#3a3',
          text: qrCodeId
        });
      }
    }
  });
})(Backbone, _, svs);
 })(window);